import { useOpenPaywallDialog } from '@features/projects/Paywall/paywall.hook';
import { guards } from '@shared/helpers/typeguards.helpers';
import { useCallback } from 'react';
import { PaywallFeature } from '@shared/models/paywall.model';

export const useProjectAction = (projectId?: number) => {
  const { openPaywallDialog, isBehindPaywall } = useOpenPaywallDialog();

  return useCallback(
    (
      action: (validProjectId: number) => void | Promise<unknown>,
      paywallAction?: PaywallFeature,
    ) => {
      return () => {
        if (paywallAction && isBehindPaywall(paywallAction)) {
          openPaywallDialog(paywallAction);
          return;
        }
        if (guards.is.undefined(projectId)) return;
        return action(projectId);
      };
    },
    [isBehindPaywall, projectId, openPaywallDialog],
  );
};
